import CardWrapper from "./CardWrapper"
import styles from "../../styles/portfolioManagerDashboard.module.scss"

function ProgressCard({ value = 68, title, infoText }) {
  return (
    <CardWrapper classNames={styles.progressCard} infoText={infoText}>
      <div className={styles.cardTop}>
        <span className={styles.label}>{title}</span>
        <div className={`${styles.cardMain}`} style={{ justifyContent: 'center' }}>
          <div className={styles.value}>{value + '%'}</div>
        </div>
      </div>
      <div className={styles.gaugeSection}>
        <div className={styles.gaugeTrack}>
          <div className={styles.gaugeFill} style={{ width: `${value}%` }} />
        </div>
        <div className={styles.gaugeLabels}>
          <span>0%</span>
          <span>100%</span>
        </div>
      </div>
    </CardWrapper>
  )
}

export default ProgressCard
